// extracted by mini-css-extract-plugin
export default {"main":"index_main_V6vP- clearfix","left":"index_left_-OuC1","right":"index_right_QBNVm","iframeheight":"index_iframeheight_rW40c"};